import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Cross from 'react-icons/lib/fa/times-circle';
import Button from 'react-bootstrap/lib/Button';
import Label from 'react-bootstrap/lib/Label';
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from './Alert';
import ReactDOM from 'react-dom';
import ReactMarkdown from 'react-markdown';
import { snakeCase } from 'lodash'
import ButtonGroup from './ButtonGroup';
import Info from 'react-icons/lib/fa/info-circle';
import CustomFormGroup from './CustomFormGroup';
import ProfileElementField from './ProfileElementField';
import { pageValid, executeValidations } from '../../validator';
import { generateProfileElementObject, changeState } from '../../utilities';

class GuestInteractionLevel extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      page: this.props.page,
      guestRelationship: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'guest_relationship')
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      lifestyle: {
        guest_relationship: this.state.guestRelationship.val
      }
    });
  }

  render() {
    const thisPage = P.GUEST_INTERACTION_LEVEL_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const guestRelationshipSelections = this.props.localProfileElements.elements.lifestyle.guest_relationship_selections;
    const guestRelationshipOptions = guestRelationshipSelections.map(t => (
      content.pages.guest_interaction.guest_relationship_options &&
        [<ReactMarkdown className="product-explanation" source={content.pages.guest_interaction.guest_relationship_options[t[0]]} />, t[1]]
    ))

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.guest_interaction.title} />
          <CustomFormGroup field={this.state.guestRelationship} className="product-checkbox">
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesGuestInteractionLabelsGuestRelationship)}</ControlLabel>
            <CheckboxOrRadioGroup
              setName={'guestRelationship'}
              type={'radio'}
              checkBoxStyle={'radio'}
              controlFunc={(e) => this.changeState('guestRelationship', e.target.value)}
              options={guestRelationshipOptions}
              selectedOptions={[this.state.guestRelationship.val]}/>
          </CustomFormGroup>
          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />
        </form>
      </div>
    )
  }
};

GuestInteractionLevel.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(GuestInteractionLevel);
